module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"selectFunctionViaNavigation":"Bitte wählen Sie über die Navigationsleiste die gewünschte Funktion aus."}}')
  delete Component.options._Ctor
}
